// @greenlight-spec: 28-it-dashboard-ui.md#internal-health--internal-health-org-admin
import * as React from 'react';

/** The key to a History chart line, beside the name the page already shows. */
export function SeriesDot({
  color,
}: {
  readonly color: string | undefined;
}): React.ReactElement | null {
  return color ? (
    <span
      aria-hidden="true"
      data-series-color={color}
      className="inline-block size-2 shrink-0 rounded-full"
      style={{ backgroundColor: color }}
    />
  ) : null;
}
